import React, { useRef } from 'react';
import Container from 'react-bootstrap/Container';
import CustomerLoginForm from '../../../components/customer/PublicCustomerScreens/CustomerFormComponents/CustomerLoginForm';
import CustomerSignupForm from '../../../components/customer/PublicCustomerScreens/CustomerFormComponents/CustomerSignupForm';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../../assets/css/customer/publicCustomerCss/CustomerFormCss/customerLogin.css';

const CustomerRegistration = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const containerRef = useRef(null);

  const isSignUpMode = location.pathname.includes('/signup');

  const toggleMode = () => {
    navigate(isSignUpMode ? '/auth/login' : '/auth/signup');
  };

  const onTouchStart = (e) => {
    containerRef.current.startX = e.targetTouches[0].clientX;
  };

  const onTouchEnd = (e) => {
    const endX = e.changedTouches[0].clientX;
    const startX = containerRef.current.startX;
    if (!startX) return;

    const diff = startX - endX;
    if (Math.abs(diff) > 50) {
      if (diff > 0 && !isSignUpMode) navigate('/auth/signup');
      else if (diff < 0 && isSignUpMode) navigate('/auth/login');
    }
    containerRef.current.startX = null;
  };

  return (
    <div className="ta-app">
      <Container
        fluid
        className={`ta-container ${isSignUpMode ? 'ta-sign-up-mode' : ''}`}
        id="ta-container"
        ref={containerRef}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
      >
        <div className="ta-form-container">
          <CustomerLoginForm />
          <CustomerSignupForm />
        </div>

        <div className="ta-color-panel">
          <h3 id="ta-panelTitle">
            {isSignUpMode ? 'Already a member?' : 'New Here?'}
          </h3>
          <p id="ta-panelText">
            {isSignUpMode
              ? 'Login to continue your travel bookings.'
              : 'Create account as Tourist or Vendor.'}
          </p>
          <button id="ta-toggleBtn" className="ta-toggle-btn" onClick={toggleMode}>
            {isSignUpMode ? 'Login' : 'Sign Up'}
          </button>
        </div>

        <div className="ta-swipe-indicator">
          <div className={`ta-swipe-dot ${!isSignUpMode ? 'ta-active' : ''}`}></div>
          <div className={`ta-swipe-dot ${isSignUpMode ? 'ta-active' : ''}`}></div>
        </div>

        <button className="ta-mobile-toggle-btn" onClick={toggleMode}>
          {isSignUpMode ? 'Login' : 'Sign Up'}
        </button>
      </Container>
    </div>
  );
};

export default CustomerRegistration;